"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trpcMiddleware = trpcMiddleware;

var _currentScopes = require("./currentScopes.js");

var _exports = require("./exports.js");

var _semanticAttributes = require("./semanticAttributes.js");

require("./tracing/errors.js");

require("./utils-hoist/debug-build.js");

require("./utils-hoist/logger.js");

require("./debug-build.js");

require("./utils-hoist/time.js");

var _normalize = require("./utils-hoist/normalize.js");

require("./utils-hoist/syncpromise.js");

var _trace = require("./tracing/trace.js");

const trpcCaptureContext = {
  mechanism: {
    handled: false,
    data: {
      function: 'trpcMiddleware'
    }
  }
};

function captureIfError(nextResult) {
  // TODO: Set span status based on what TRPCError was encountered
  if (typeof nextResult === 'object' && nextResult !== null && 'ok' in nextResult && !nextResult.ok && 'error' in nextResult) {
    (0, _exports.captureException)(nextResult.error, trpcCaptureContext);
  }
}
/**
 * Sentry tRPC middleware that captures errors and creates spans for tRPC procedures.
 */


function trpcMiddleware(options = {}) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return async function (opts) {
    const path = opts.path,
          type = opts.type,
          next = opts.next,
          rawInput = opts.rawInput,
          getRawInput = opts.getRawInput;
    const client = (0, _currentScopes.getClient)();
    const clientOptions = client && client.getOptions();
    const trpcContext = {
      procedure_path: path,
      procedure_type: type
    };

    if (options.attachRpcInput !== undefined ? options.attachRpcInput : clientOptions && clientOptions.sendDefaultPii) {
      if (rawInput !== undefined) {
        trpcContext.input = (0, _normalize.normalize)(rawInput);
      }

      if (getRawInput !== undefined && typeof getRawInput === 'function') {
        try {
          const rawRes = await getRawInput();
          trpcContext.input = (0, _normalize.normalize)(rawRes);
        } catch (err) {// noop
        }
      }
    }

    return (0, _currentScopes.withScope)(scope => {
      scope.setContext('trpc', trpcContext);
      return (0, _trace.startSpanManual)({
        name: `trpc/${path}`,
        op: 'rpc.server',
        attributes: {
          [_semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'route',
          [_semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.rpc.trpc'
        }
      }, async span => {
        try {
          const nextResult = await next();
          captureIfError(nextResult);
          span.end();
          return nextResult;
        } catch (e) {
          (0, _exports.captureException)(e, trpcCaptureContext);
          span.end();
          throw e;
        }
      });
    });
  };
}